<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="项目" prop="project_id">
                            <Select v-model="Forms.project_id" disabled clearable filterable  placeholder="项目">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}}({{item.status_name}})</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户" prop="customer_id">
                            <Select v-model="Forms.customer_id" disabled clearable filterable  placeholder="客户" class="width-100">
                                <Option v-for="(item,index) in customerList" :key="index" :value="item.id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票金额" prop="inv_money">
                            <Input v-model="Forms.inv_money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="到账金额" prop="get_money">
                            <Input v-model="Forms.get_money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票类型" prop="inv_type">
                            <Select v-model="Forms.inv_type" clearable filterable  placeholder="收款类型" class="width-100">
                                <Option v-for="(item,index) in invTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票公司" prop="inv_company_id">
                            <Select v-model="Forms.inv_company_id" clearable filterable  placeholder="开票公司" class="width-100">
                                <Option v-for="(item,index) in invCompanyList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="上传发票" prop="invoice_image">
                            <Input v-model="Forms.invoice_image" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票抬头" prop="inv_head">
                            <Input v-model="Forms.inv_head" class="width-70" clearable placeholder="" />
                            &nbsp;<Button type="primary" class="width-27" ghost @click="getContact">自动获取</Button>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票税号" prop="inv_num">
                            <Input v-model="Forms.inv_num" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票地址" prop="inv_address">
                            <Input v-model="Forms.inv_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="inv_bank">
                            <Input v-model="Forms.inv_bank" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认开发票</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getIncomeConfig, getIncomeDetail} from "@/apis/income";
import {getCustomerInvoice} from "@/apis/customer";
import {saveInvoice} from "@/apis/invoice";

export default {
    name: 'IncomeInvoice',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '开发票',
            isBox : false,
            invTypeList: [],
            projectList: [],
            customerList: [],
            invCompanyList: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                income_id: '',
                project_id: '',
                customer_id: '',
                inv_money: '',
                get_money: '',
                invoice_image: '',
                inv_type: '',
                inv_company_id: '',
                inv_head: '',
                inv_num: '',
                inv_address: '',
                inv_bank: '',
                remark: ''
            },
            Rules : {
                inv_money: [
                    { required: true, type: 'number', min:0.1 ,  message: '请输入开票金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                get_money: [
                    { required: true, type: 'number', min:0.1,  message: '请输入到账金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                inv_type: [
                    { required: true, type: 'number',  message: '请选择发票类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                invoice_image: [
                    { required: true, message: '请上传发票', trigger: 'blur'}
                ],
                inv_company_id: [
                    { required: true, type: 'number',  message: '请选择开票公司', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                inv_head: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur'}
                ],
                inv_num: [
                    { required: true, message: '请输入发票税号', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.invoice_image = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.invoice_image = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.invoice_image){
                //下载文件
                const fileUrl = that.site_url + that.Forms.invoice_image; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/26 16:08
         **/
        getContact(){
            let that = this;
            if(!that.Forms.customer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择客户'});
                return;
            }
            getCustomerInvoice(that.Forms.customer_id).then(e => {
                let data = e.data;
                that.Forms.inv_head = data.inv_head ?? '';
                that.Forms.inv_num = data.inv_num ?? '';
                that.Forms.inv_bank = data.inv_bank ?? '';
                that.Forms.inv_address = data.inv_address ?? '';
            })
        },
        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getIncomeConfig().then(e=>{
                that.invTypeList = e.data.invTypeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.invCompanyList = e.data.invCompanyList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/25 18:19
         **/
        GetIncome(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getIncomeDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'project_id' || v === 'customer_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'income_id' ) {
                        that.Forms[v] = data['id'];
                    }else if(v === 'inv_money' ) {
                        that.Forms[v] = data['true_money'];
                    }else if(v === 'get_money' ) {
                        that.Forms[v] = data['true_money'];
                    }else if(v === 'id' ) {
                        that.Forms[v] = '';
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                console.log(that.Forms)
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(income_id, project_name){
            this.isBox = true;
            this.title = project_name + ' - 开发票';
            if(income_id){
                this.Forms.income_id = income_id;
                this.GetIncome(income_id);
            }
            this.GetConfig();
        },

        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveInvoice(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/26 16:18
         **/
        FormReset(){
            this.isBox = false;
            this.title = '开发票';
            this.$refs['Forms'].resetFields();
            this.Forms.invTypeList = [];
            this.Forms.projectList = [];
            this.Forms.customerList = [];
            this.Forms.invCompanyList = [];
            this.Forms.income_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
